require('./helpers/bundle-manifest').register(JSON.parse("{\"iws3x\":\"lifecycle.96b0f28a.js\",\"5D56N\":\"1.cfbe3101.jpg\"}"));